import React from "react";
import "./DashboardContent.css";
import Floaticons from "./Floaticons";

function DashboardContent() {
 return (
  <>
   <div className="main-banner">
    <img
     src="/images/Dashboard/dashboard-bannerv2.png"
     alt="Learning Dashboard Banner"
     className="dashboard-banner"
    />
    <Floaticons />
   </div>
   <div className="dashboard-container">
    <div className="dashboard-wrap">
     <h1 class="visually-hidden">Learning Dashboard</h1>
     <p>
      You can now track your learning progress with a simple click! <br /> Check the
      learning summary, weekly progress data, and trends for each track in the below
      dashboard.
     </p>

     <iframe
      title="ABC University Learning Dashboard"
      width="1140"
      height="541.25"
      src="
https://app.powerbi.com/reportEmbed?reportId=acec6cf8-73b5-497c-93ad-6df93d68cc03&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
      frameborder="0"
      allowFullScreen="true"
     ></iframe>
    </div>
   </div>
  </>
 );
}
export default DashboardContent;
